// extracted by mini-css-extract-plugin
export default {"hr_muted":"SubHeadingComponent_hr_muted__FZbY+"};